<template>
  <div class="container">
    <Tbheader
      :tipo="tipo + ' - equipe'"
      :novo="novo"
      :titulo="contentEdit.titulo"
      :icone="icone"
    />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-12 form-group">
          <label>Idioma:</label>
          <select
            v-model="contentEdit.quemSomosId"
            name="quemSomosId"
            id="quemSomosId"
            class="form-control required valid"
            value
            @change="fnMudaIdioma()"
          >
            <option
              :key="idioma.quemSomosId"
              v-for="idioma in contentIdiomas"
              :value="idioma.quemSomosId"
            >
              {{ idioma.idioma }}
            </option>
          </select>
        </div>
        <div class="col-10 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>

          <div class="col-md-2 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.ativo == true}"
            >
              <input type="radio" name="ativo" id="ativo" @change="fnAtiva() " :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.ativo == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @change="fnAtiva()"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
          </div>

         <div class="col-sm-12"><label>Imagem:</label></div>
        <div class="col-sm-6 text-center">
          <div
            class="areaFoto"
            :class="contentEdit.imagem ? 'ativo' : ''"
            @click="$refs.imagem.click()"
            :style="
              contentEdit.imagem && carregado
                ? 'background:url(' + contentEdit.imagem + ')'
                : 'background:url()'
            "
          >
            <i class="icon-cloud-upload-alt"></i>
            <input
              type="file"
              @change="OnFileSelected"
              id="imagem"
              name="imagem"
              ref="imagem"
              style="display: none"
              class="form-control"
              accept="image/*"
            />
          </div>
          <button
            v-if="contentEdit.imagem && tipo != 'Copiando'"
            class="btn btn-danger"
            @click.prevent="fnRemoveFoto('imagem', 1)"
          >
            Remover foto
          </button>
          <button
            type="button"
            v-if="tipo == 'Copiando'"
            class="btn btn-info"
            @click.prevent="$refs.imagem.click()"
          >
            Alterar foto
          </button>
        </div>         
       <div class="col-sm-12">
            <label>Texto</label>
            <textarea
            class="form-control"
            v-model="contentEdit.texto"
            name="texto"
            id="texto"
            >


            </textarea>
        </div>
        <div class="col-12 form-group"></div>
        
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >
            Gravar
          </button>
        </div>
      </div>
      <div style="display: none;">{{carregadoImg}}</div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData, getSuccess, getError, urlApi } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      carregadoIm: false,
      error: null,      
      idiomaAnterior: null,
      contentFotos: [],
      carregado: true,
      files: [],
      imagem: [],
      contentIdiomas: [],
      logotipoRodape: [],
      contentEdit: {
        titulo: "",
        ativo: false,
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  components: { Tbheader},
  methods: {
       OnFileSelected(event) {
      if (event.target.id == "imagem") {
        this.contentEdit.imagem = URL.createObjectURL(event.target.files[0]);
        this.imagem = event.target.files[0];
        this.carregado = true;
        this.carregadoIm = true;
      }
    },
    fnRemoveFoto(tipo, i) {
      var filename = "";
      if (i == 1) {
        filename = this.contentEdit.imagem
          .split("/")
          .pop()
          .split("#")[0]
          .split("?")[0];
        this.contentEdit.imagem = null;
      }
      this.$http
        .delete(
          "gape/upload/gape/equipe/" +
            this.contentEdit.idioma +
            "/" +
            filename +
            "/arquivo"
        )
        .then((res) => {
          console.log(res);
        });
    },
    fnCopyFoto() {
      var filename = "";
      var idioma = "";
      filename = this.contentEdit.imagem
        .split("/")
        .pop()
        .split("#")[0]
        .split("?")[0];
      idioma = this.contentEdit.imagem.split("/");

      this.contentEdit.imagem = null;
      var idiomaAnterior = idioma[5];
      this.$http
        .post(
          "gape/upload/gape/equipe/" +
            this.contentEdit.idioma +
            "/" +
            filename +
            "/" +
            idiomaAnterior +
            "/copiar"
        )
        .then((res) => {
          console.log(res);
        });
    },
    GetFilename(url) {
      if (url) {
        var m = url.toString().match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if (this.imagem.name != undefined) {
        fd.append("files", this.imagem, this.imagem.name);
      }

      this.$http
        .post("gape/upload/gape/" + this.contentEdit.idioma + "/equipe", fd)
        .then(() => {
          this.carregado = true;
        });
    },
    fnLimpa() {
      this.contentEdit.titulo = "";
      this.contentEdit.ativo = "";
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
      this.contentEdit.ativo = !this.contentEdit.ativo;
    },
    fnCancela() {
      this.$router.push({ path: `/gape/equipe/` });
    },
    async formSubmit(e) {
      e.preventDefault();
       let metodo = null
       let completaUrl = null
       if(this.$route.meta.breadcrumb == "Copiar"){
        metodo = "post";
        delete this.contentEdit["equipeId"];
        completaUrl = "";
      }else{
        metodo = this.$route.params.id ? "put" : "post";
       completaUrl = this.$route.params.id
        ? "/" + this.$route.params.id
        : "";
      }

      const imgUrl =
        urlApi + "Upload/gape/" + this.contentEdit.idioma + "/equipe/";
      var chamaUpload = false;
      if (this.imagem.name != undefined) {
        chamaUpload = true;
        this.contentEdit.imagem =
          imgUrl + this.imagem.name;
      }

        if (this.idiomaAnterior != this.contentEdit.idioma) {
          this.contentEdit.imagem = this.contentEdit.imagem.replace(this.idiomaAnterior,this.contentEdit.idioma)
        }
      let data = await this.$http[metodo](
        "/gape/equipe" + completaUrl,
        this.contentEdit
      )
        .then(() => {
          if (chamaUpload) {
            this.OnUpload();
          }
          if( this.tipo == "Copiando"){
            this.fnCopyFoto();
          }
          getSuccess();
          this.fnLimpa();
          this.fnCancela();
        })
        .catch((e) => {
          return e;
        });
      this.error = data;
    },
    fnGetError(e) {
      getError(e);
    },
    fnIsEdit() {
      console.log(this.$route.meta.breadcrumb)
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        if(this.$route.meta.breadcrumb == "Copiar"){
        this.tipo = "Copiando";
        this.novo = true;
        this.fnCarregaItems(this.$route.params.id);

        }else{
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id);

        }
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false;
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    fnMudaIdioma() {
      this.contentEdit.idioma = this.contentIdiomas[this.contentEdit.quemSomosId - 1].idioma
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi + "gape/equipe/" + valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close();
      if (this.tipo == "Copiando") {
          this.idiomaAnterior = this.contentEdit.idioma
      }

    },
    async fnCarregaIdiomas() {
      let data = await getData(this.urlApi + "gape/quemSomos/");
      console.log(data);
      this.contentIdiomas = data[0].content;
    },
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function () {
      return this.fnIsEdit();
    },
    temErro() {
      if (this.error) {
        return this.fnGetError(this.error);
      } else {
        return "";
      }
    },
    carregadoImg() {
      if (this.carregadoIm) {
        return this.contentEdit;
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.fnCarregaIdiomas();
  },
};
</script>

<style lang="scss" scoped>
#editor1,
#editor2,
#editor3 {
  min-height: 50vh;
}
</style>